export const environment = {
    wavix_api_id: "63783a8081b2b15ff0277872ffec4a202f84174afe596b34eab8510d2fc894c8",
    api_client_service: "https://dtcb.gybsupport.com"
    //api_client_service: "http://localhost:8001"
}
